import React from 'react'
import { css, useTheme } from '@emotion/react'
import { Carousel, Typography } from '../base-ui'
import Image from '../base-ui/Image'
import { MediaQuery } from '../base-ui/Utility'

function HomeCarousel() {
    const theme = useTheme()

    const dotStyle = `
        .dots {
            position: absolute;
            display: flex;
            width: 200px;
            z-index: 9;
            bottom: 50px;
            right: 70px;
            left: auto;
            flex-direction: row-reverse;
            gap: 0.5rem;
            svg {
                font-size: 18px;
                color: #ffffff;
            }
            .active svg {
                fill: #ffffff;
                background-color: #ffffff;
                border-radius: 50%;
            }
        }
        ${MediaQuery('sm', 'max')} {
            .dots {
                width: 100%;
                right: auto;
                justify-content: center;
            }
        }
    `
    const style = css`
        width: 100%;
        height: 720px;
        position: relative;
        .h1 {
            text-shadow: 2px 1px 10px #4c4c4c;
        }
        .gradient {
            background: linear-gradient(
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.45) 100%
            );
            width: 100%;
            height: 40%;
            position: absolute;
            z-index: 3;
            bottom: 0;
        }
        .overlay {
            position: absolute;
            z-index: 2;
            background-color: rgba(0, 0, 0, 0.1);
            border-color: rgba(0, 0, 0, 0);
            border-width: 0px;
            background-image: url('img/project/rrdiagonal-line.png');
            visibility: inherit;
            transition: none 0s ease 0s;
            text-align: left;
            line-height: 24px;
            margin: 0px;
            padding: 0px;
            letter-spacing: 0px;
            font-weight: 400;
            font-size: 16px;
            white-space: nowrap;
            height: 720px;
            width: 100%;
            opacity: 1;
            transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            transform-origin: 50% 50% 0px;
        }
    `
    const textBox = css`
        max-width: 45rem;
        position: absolute;
        z-index: 9;
        left: 70px;
        bottom: 50px;
        display: flex;
        flex-wrap: wrap;
        .title {
            flex-basis: 100%;
            text-shadow: 0 0 7px black;
        }
        .content {
            flex-basis: 65%;
            text-shadow: 0 0 7px black;
        }
        .action: {
            flex-basis: 35%;
        }
        ${MediaQuery('sm', 'max')} {
            .h1 {
                font-size: 4rem;
            }
            left: auto;
            bottom: auto;
            top: 150px;
            justify-content: center;
            .title,
            .content,
            .action {
                flex-basis: 80%;
                text-align: center;
                justify-content: center;
            }
        }
    `

    const actionStyle = css`
        display: flex;
        gap: 0.5rem;
        align-self: center;
        .actionButton {
            border: 1px solid #888888;
            color: ${theme.colors.lighterGray};
            border-radius: 0;
            padding: 0.5rem;
            justify-content: center;
        }
        .wide {
            width: 13rem;
        }
    `

    const carouselSettings = {
        rtl: true,
        loop: true,
        controls: false,
        autoSwitch: true,
        dots: true,
        preview: { sm: 1, md: 1, lg: 1, xl: 1, xxl: 1 },
        style: dotStyle
    }

    return (
        <div>
            <Carousel {...carouselSettings}>
                <div className="keen-slider__slide" css={style}>
                    <div className="box" css={textBox}>
                        <Typography
                            className="title"
                            type="h1"
                            fontSize="5.5rem"
                            fontWeight="Bold"
                            color="white"
                        >
                           
                        </Typography>
                        <Typography
                            className="content"
                            type="p"
                            fontSize="1.1rem"
                            fontWeight="Semi Bold"
                            color="lightGray"
                        >
                        </Typography>
                        <div className="action" css={actionStyle}>
                            {/* <Button className="wide actionButton">
                               
                            </Button> */}
                        </div>
                    </div>
                    <div className="gradient"></div>
                    {/* <div className="overlay"></div> */}
                    <Image
                        layout="fill"
                        objectFit="cover"
                        src="/img/zeolite/slide-01.jpg?562"
                        priority={true}
                        alt=""
                    />
                </div>
                <div className="keen-slider__slide" css={style}>
                    <div className="box" css={textBox}>
                        <Typography
                            className="title"
                            type="h1"
                            fontSize="5.5rem"
                            fontWeight="Bold"
                            color="white"
                        >
                        </Typography>
                        <Typography
                            className="content"
                            type="p"
                            fontSize="1.1rem"
                            fontWeight="Semi Bold"
                            color="lightGray"
                        >
                        </Typography>
                        <div className="action" css={actionStyle}>
                            {/* <Button className="wide actionButton">
                                Read More
                            </Button> */}
                        </div>
                    </div>
                    <div className="gradient"></div>
                    {/* <div className="overlay"></div> */}
                    <Image
                        layout="fill"
                        objectFit="cover"
                        src="/img/zeolite/slide-02.jpg?1233"
                        priority={true}
                        alt=""
                    />
                </div>
            </Carousel>
        </div>
    )
}

export default HomeCarousel
